import { combineReducers } from 'redux'

import projects from './project_reducers'

const reducer = combineReducers({
	projects
})

export default reducer